
export enum HorairesOuvertureDepartmentEnum {
    APV = 1,
    Commerce = 2,
}

export enum WeekDayEnum {
    Sunday = "0",
    Monday = "1",
    Tuesday = "2",
    Wednesday = "3",
    Thursday = "4",
    Friday = "5",
    Saturday = "6",
}

export const WeekDayLabel = {
    [WeekDayEnum.Monday]: "Lundi",
    [WeekDayEnum.Tuesday]: "Mardi",
    [WeekDayEnum.Wednesday]: "Mercredi",
    [WeekDayEnum.Thursday]: "Jeudi",
    [WeekDayEnum.Friday]: "Vendredi",
    [WeekDayEnum.Saturday]: "Samedi",
    [WeekDayEnum.Sunday]: "Dimanche",
}

export type TimeSlot = [string, string]
export type BusinessHours = Partial<Record<WeekDayEnum, TimeSlot[]>>

export interface WorkingHourSpecificPeriod {
    label: string
    startDate: string
    endDate: string
    businessHours: BusinessHours
}

export interface WorkingHour {
    id?: number
    dealershipIds: number[] | null
    department: HorairesOuvertureDepartmentEnum
    schedules: {
        businessHours: BusinessHours
        specificPeriod?: WorkingHourSpecificPeriod[]
    }
}

export interface HorairesOuverture {
    Departement: HorairesOuvertureDepartmentEnum
    Horaires: string
    IDSite: number
    IDWorkingHours: number
}

export interface HolidayDate {
    id?: number
    name: string
    country?: string
    date: string
    isManual: boolean
    isRecurrent?: boolean
    selected?: boolean
    dealershipIds: number[]
}

export interface JourFerie {
    IDJourFerie: number
    Nom: string
    Date: string
    EstManuel: boolean
}

export interface NagerAPIHoliday {
    countryCode: string
    date: string
    fixed: boolean
    global: true
    localName: string
}
